/**
 * Feedback Display Component
 * Shows AI evaluation results for submitted answers
 */
import React from 'react';

const FeedbackDisplay = ({ feedback, sessionMode }) => {
  const isAIEvaluation = !sessionMode || sessionMode === 'ai';
  const evaluation = feedback.evaluation;

  const getScoreEmoji = (score) => {
    if (score >= 80) return '🌟';
    if (score >= 60) return '👍';
    return '⚠️';
  };

  if (sessionMode === 'flashcard') {
    return (
      <div className="feedback-container">
        <div className="feedback-card success">
          <div className="feedback-header">
            <span className="feedback-icon">✨</span>
            <span>Reference Answer</span>
          </div>
          <div className="feedback-text">{feedback.correct_answer}</div>
        </div>
      </div>
    );
  }

  if (sessionMode === 'self') {
    return (
      <div className="feedback-container">
        <div className="feedback-card partial">
          <div className="feedback-header">
            <span className="feedback-icon">📝</span>
            <span>Your Assessment: {feedback.self_feedback}</span>
          </div>
          <div className="feedback-text">
            <strong>Reference Answer:</strong>
            <br />
            {feedback.correct_answer}
          </div>
        </div>
      </div>
    );
  }

  // AI Evaluation mode
  return (
    <div className="feedback-container">
      <div className={`feedback-card ${evaluation.score >= 80 ? 'success' : evaluation.score >= 60 ? 'partial' : 'error'}`}>
        <div className="feedback-header">
          <span className="feedback-icon">{getScoreEmoji(evaluation.score)}</span>
          <span>AI Evaluation Results</span>
        </div>

        <div className="evaluation-results">
          <div className="evaluation-metric">
            <div className="metric-value">{evaluation.score}</div>
            <div className="metric-label">Overall Score</div>
          </div>
          <div className="evaluation-metric">
            <div className="metric-value">{evaluation.accuracy}</div>
            <div className="metric-label">Accuracy</div>
          </div>
          <div className="evaluation-metric">
            <div className="metric-value">{evaluation.coverage}</div>
            <div className="metric-label">Coverage</div>
          </div>
          <div className="evaluation-metric">
            <div className="metric-value">{evaluation.clarity}</div>
            <div className="metric-label">Clarity</div>
          </div>
        </div>

        <div style={{
          marginTop: 'var(--space-6)',
          paddingTop: 'var(--space-6)',
          borderTop: '1px solid var(--border)',
        }}>
          <h4 style={{
            fontSize: 'var(--text-base)',
            fontWeight: 'var(--font-weight-700)',
            color: 'var(--text-primary)',
            marginBottom: 'var(--space-3)',
          }}>
            📝 Your Answer
          </h4>
          <p style={{
            fontSize: 'var(--text-sm)',
            color: 'var(--text-secondary)',
            lineHeight: '1.6',
            marginBottom: 'var(--space-6)',
          }}>
            {feedback.user_answer}
          </p>

          <h4 style={{
            fontSize: 'var(--text-base)',
            fontWeight: 'var(--font-weight-700)',
            color: 'var(--text-primary)',
            marginBottom: 'var(--space-3)',
          }}>
            ✅ Reference Answer
          </h4>
          <p style={{
            fontSize: 'var(--text-sm)',
            color: 'var(--text-secondary)',
            lineHeight: '1.6',
          }}>
            {feedback.correct_answer}
          </p>
        </div>

        <div className="feedback-text">
          <strong>Feedback:</strong> {evaluation.feedback}
        </div>

        <div className="improvements">
          <div className="improvements-title">🚀 Improvement Tips</div>
          <ul className="improvements-list">
            {evaluation.improvement_tips.split('\n').filter(tip => tip.trim()).map((tip, idx) => (
              <li key={idx} className="improvement-item">{tip.trim()}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FeedbackDisplay;
